export default "__VITE_ASSET__B1s1Ipq___"